module.exports = __webpack_public_path__ + "img/gear.f6bb9b26.svg";